import { BLOCK_CLASSES as e } from "../../constants.js";
import { defineAttrs as t } from "../../utils/typed-attrs.js";
import { stylable as n } from "../decorators/stylable.js";
import "../decorators.js";
var r = n({
	content: "",
	group: "block",
	attrs: t({
		type: { default: "horizontalRule" },
		width: { default: "" }
	}),
	parseDOM: [{ tag: "hr" }],
	toDOM(t) {
		return [
			"div",
			{ class: `${e.divider} intercom-divider-container` },
			["div", ["hr"]]
		];
	}
});
//#endregion
export { r as horizontalRuleSpec };
